import React from 'react';

import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import InviteNewMembers from 'buyside/components/presentation/InviteNewMembers/InviteNewMembersPage';

const InviteNewMembersPageRoot = ({ isRetail }) => {
  return (
    <ErrorBoundary pageName="new member invitations">
      <InviteNewMembers isRetail={isRetail === 'true'} />
    </ErrorBoundary>
  );
};

export default InviteNewMembersPageRoot;
